import React from "react";
import { DepositDefinition } from "../../models/DepositDefinition";
import "./ecardDefinitions.scss";
import { useTranslation } from "react-i18next";
import { BsCheckCircle, BsCircle } from "react-icons/bs";

interface IProps {
  activeDefinition: number;
  item: DepositDefinition;
  handleState: (num: number, price:number) => void;
}

const EcardDefinition: React.FC<IProps> = ({ item, handleState, activeDefinition }: IProps) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => handleState(item.objectId, item.amountVat7)}
      className={
        item.objectId === activeDefinition
          ? "active-definition definition flex-start-center"
          : "definition flex-start-center"
      }
    >
         {item.objectId !== activeDefinition && <BsCircle className="icon" />}
          {item.objectId === activeDefinition  && <BsCheckCircle className="icon" />}
      <div className="definition__details">
      <b>{item.description}</b>
      <span>
        {t("waznosc")}: +{item.dayPeriod} {t("dni")}

      </span>

      </div>
  
    </div>
  );
};

export default EcardDefinition;
